import { render, staticRenderFns } from "./ShipmentPrototypeItem.vue?vue&type=template&id=49eb5208&scoped=true"
import script from "./ShipmentPrototypeItem.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypeItem.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPrototypeItem.vue?vue&type=style&index=0&id=49eb5208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eb5208",
  null
  
)

export default component.exports